import React, { useState } from "react";
import { businessCategories } from "../Home/BusinessCategories";
// import AdsCard from "../../components/common/AdsCard/AdsCard";
import Heading from "../../components/common/Typography/Heading";
import MovingLeft from "../../components/common/FullLengthSwipers/MovingLeft";
import MovingRight from "../../components/common/FullLengthSwipers/MovingRight";
import DoubleLineSliderCard from "../../components/common/AdsCard/DoubleLineSliderCard";
import AdsCard from "../../components/common/AdsCard/AdsCard";
import Login from "../../sections/Login/Login";
import { SignUp } from "../../sections/SignUp/SignUp";
import SharePopup from "../../components/common/SharePopup/SharePopup";
import { useLocation } from "react-router-dom";
import {
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const DoubleLineSlider = () => {
  const location = useLocation();
  const [SignUpState, setSignUpState] = useState(false);
  const [SignIn, setSignIn] = useState(false);
  const [sharePopupOpen, setSharePopupOpen] = useState(false);
  const [shareData, setShareData] = useState({});

  // Handle popup state changes from AdsCard components
  const handleSignInChange = (newSignInState) => {
    setSignIn(newSignInState);
  };

  const handleSignUpChange = (newSignUpState) => {
    setSignUpState(newSignUpState);
  };

  const handleSharePopup = (isOpen, data = {}) => {
    setSharePopupOpen(isOpen);
    setShareData(data);
  };

  return (
    <>
    <div className={PUBLIC_SECTION_GAP_CLASS}>
      {/* Render popups outside of sliders for proper positioning */}
      {SignIn && (
        <Login
          location={location.pathname + location.search}
          SignIn={SignIn}
          setSignIn={handleSignInChange}
          SignUpState={SignUpState}
          setSignUpState={handleSignUpChange}
        />
      )}
      {SignUpState && (
        <SignUp
          location={location.pathname + location.search}
          SignUpState={SignUpState}
          setSignUpState={handleSignUpChange}
          SignIn={SignIn}
          setSignIn={handleSignInChange}
        />
      )}
      {sharePopupOpen && (
        <SharePopup
          isOpen={sharePopupOpen}
          onClose={() => handleSharePopup(false)}
          postTitle={shareData.postTitle || ""}
          currentUrl={shareData.currentUrl || ""}
          variant="project"
          previewImage={shareData.previewImage}
          projectTitle={shareData.projectTitle || shareData.postTitle}
          businessName={shareData.businessName}
          previewCompanyLogo={shareData.previewCompanyLogo}
        />
      )}

      <div className="tp-container-main mx-auto">
        <Heading variant={"h2"} className={"text-offblack"}>
          Recommended Mixer repair services near you
        </Heading>
      </div>
      <div className={PUBLIC_HEADING_TO_CONTENT_CLASS}>
        <MovingLeft speed="300s">
          {businessCategories
            .sort((a, b) =>
              a.businessCategoryName.localeCompare(b.businessCategoryName)
            )
            .map((item, index) => (
              <div className="sliderImg" key={index}>
                <div className="m-2 sm:m-4">
                  <div className="w-[300px] lg:w-[413px]">
                  <AdsCard
                    key={index}
                    serviceName={item.businessCategoryName}
                    // serviceDescription={e?.description}
                    // category={
                    //   e?.category ?? e?.listingCategory?.businessCategoryName
                    // }
                    // type={e?.listType}
                    Images={require("../../assets/img/default-image.jpg")}
                    // rating={e?.listRating}
                    companyName={"Spark Flow"}
                    companyLogo={require("../../assets/img/User.png")}
                    // serviceId={e?.listingId ?? e.id}
                    // companyId={e?.companyId ?? e?.userProfile?.company?.id}
                    // reaction={e?.listReaction}
                    // Pass popup handlers to AdsCard
                    onSignInChange={handleSignInChange}
                    onSignUpChange={handleSignUpChange}
                    onSharePopup={handleSharePopup}
                  />
                  </div>
                </div>
              </div>
            ))}
        </MovingLeft>
      </div>
      <div>
        <MovingRight speed="300s">
          {businessCategories
            .sort((a, b) =>
              a.businessCategoryName.localeCompare(b.businessCategoryName)
            )
            .map((item, index) => (
              <div className="sliderImg" key={index}>
                <div className="m-2 sm:m-4">
                  <div className="w-[300px] lg:w-[413px]">
                  <AdsCard
                    key={index}
                    serviceName={item.businessCategoryName}
                    // serviceDescription={e?.description}
                    // category={
                    //   e?.category ?? e?.listingCategory?.businessCategoryName
                    // }
                    // type={e?.listType}
                    Images={require("../../assets/img/default-image.jpg")}
                    // rating={e?.listRating}
                    companyName={"Spark Flow"}
                    companyLogo={require("../../assets/img/User.png")}
                    // serviceId={e?.listingId ?? e.id}
                    // companyId={e?.companyId ?? e?.userProfile?.company?.id}
                    // reaction={e?.listReaction}
                    // Pass popup handlers to AdsCard
                    onSignInChange={handleSignInChange}
                    onSignUpChange={handleSignUpChange}
                    onSharePopup={handleSharePopup}
                  />
                  </div>
                </div>
              </div>
            ))}
        </MovingRight>
      </div>
      
      </div>
    </>
  );
};

export default DoubleLineSlider;
